// sort-imports-ignore
import '@mantine/charts/styles.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';

import { PropsWithChildren, useMemo } from 'react';
import '../assets/fonts.css';
import '../assets/scss/main.scss';
import './global.module.css';

import {
  DefaultMantineColor,
  MantineColor,
  MantineColorsTuple,
  MantineProvider,
  MantineTheme,
  MantineThemeOverride,
  createTheme,
  getGradient,
  mergeThemeOverrides,
  rem,
  useMantineTheme,
} from '@mantine/core';

import cx from 'clsx';

import tokens from '../../design/tokens';

import { ModalsProvider } from '@mantine/modals';
import { NotificationProvider } from '../Feedback';
import { defaultThemOverride } from '../theme/default';
import { resolver } from '../theme/variableResolver';

// interface UiProviderComponents extends MantineProviderProps['theme']['components'] {

interface UiProviderProps extends PropsWithChildren {
  theme?: MantineThemeOverride;
}

// const myCache = createEmotionCache({ key: 'gb-ui' });

export const UiProvider = ({ children, theme }: UiProviderProps) => {
  const _theme = useMemo(() => {
    const newTheme = createTheme(theme ?? {});
    return mergeThemeOverrides(defaultThemOverride, newTheme);
  }, [theme]);
  return (
    <MantineProvider
      theme={_theme}
      cssVariablesResolver={resolver}
      // emotionCache={myCache}
    >
      <ModalsProvider>{children}</ModalsProvider>
      <NotificationProvider />
    </MantineProvider>
  );
};
// export type { MantineStyleSystemProps as defaultMantineSystemProps } from '@mantine/core';

const getStylesRef = (name: string) => name;

export { cx, getGradient, getStylesRef, rem, useMantineTheme };

type CSSObject = any;

export type { CSSObject, MantineColor, MantineTheme };

type ExtendedCustomColors =
  | 'cobalt'
  | 'tangerine'
  | 'lightBlue'
  | 'mint'
  | 'cerise'
  | 'rose'
  | 'slate'
  | DefaultMantineColor;

declare module '@mantine/core' {
  export interface MantineThemeColorsOverride {
    colors: Record<ExtendedCustomColors, MantineColorsTuple>;
  }
  export interface MantineThemeOther {
    tokens: typeof tokens;
  }
  export interface ModalProps {
    variant?: 'right-aligned' | 'full-screen-mobile';
  }
  export interface MenuItemProps {
    variant?: 'destructive';
  }
}
